import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"


const initialState = { status: null, loading: false, data: [],total:0,error: "", message: "" }

export const testPostbackAction = createAsyncThunk(
    'postback-log',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`${process.env.REACT_APP_API_ENDPOINT}/api/test/postback`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const testPostbackSlice = createSlice({
    name: 'postback-log',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(testPostbackAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(testPostbackAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData
            })
            builder.addCase(testPostbackAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
                state.total = action?.payload?.totalData

            })
        },

})



export const testPostbackReducer = testPostbackSlice.reducer